import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import MenuPreview from "./components/MenuPreview";
import StorySection from "./components/StorySection";
import ContactSection from "./components/ContactSection";
import InstagramSection from "./components/InstagramSection";

export default function Home() {
  return (
    <main className="min-h-screen">
      <Navbar />
      <HeroSection />
      <MenuPreview />
      <StorySection />
      <ContactSection />
      <InstagramSection />
      <Footer />
    </main>
  );
}
